import { useMemo } from 'react';
import { createAuthenticatedApiClient } from '../../../shared/api/apiClient';
import { rpcCall } from '../../../shared/api/rpcClient';
import { useAuth } from '../../auth/context/AuthContext';
import type {
  FeatureSwitchesView,
  FeatureSwitchMove,
  SetFeatureSwitchRequest,
} from '../../../types/backend';

// Feature switches: which are on for the caller, and the one change, setting a switch. Who may set
// one is Cedar's decision on the server, never this client's.
export interface FeatureSwitchService {
  getFeatureSwitches(): Promise<FeatureSwitchesView>;
  setFeatureSwitch(request: SetFeatureSwitchRequest): Promise<FeatureSwitchMove>;
}

export const createFeatureSwitchService = (idToken: string): FeatureSwitchService => {
  const client = createAuthenticatedApiClient(idToken);

  return {
    getFeatureSwitches: () => rpcCall(client, 'ops.GetFeatureSwitches', {}),

    setFeatureSwitch: (request) => rpcCall(client, 'ops.SetFeatureSwitch', request),
  };
};

export const useFeatureSwitchService = (): FeatureSwitchService => {
  const { idToken } = useAuth();

  // One client per token, so the query hooks that depend on the service keep a stable reference.
  return useMemo(() => {
    if (!idToken) {
      throw new Error('Not authenticated');
    }
    return createFeatureSwitchService(idToken);
  }, [idToken]);
};
